<div class="flex mrt-1 mrb-1">
    <form class="flex a-center">
        @for (item of config; track item; let i = $index) {
            <ng-container>
                @if (item.type === 'input') {
                    <div class="mrr-1">
                        <mat-form-field>
                            <mat-label>{{ item.label }}</mat-label>
                            <input
                                [(ngModel)]="formValues[item.name]"
                                (ngModelChange)="onSearch()"
                                [name]="item.name"
                                [ngModelOptions]="{ standalone: true }"
                                [placeholder]="item.placeholder || ''"
                                [type]="'text'"
                                matInput
                                class="t-ellipsis"
                                [matTooltip]="item.label"
                            />
                        </mat-form-field>
                    </div>
                }

                @if (item.type === 'common-dropdown' && item.commonDropdownConfig) {
                    <div class="mrr-1">
                        <app-common-dropdown
                            [formCtrl]="item.commonDropdownConfig.formCtrl"
                            [label]="item.label"
                            [service]="item.commonDropdownConfig.service"
                            (onSelectOption)="applyCommonDropdownFilter(item, $event)"
                            [noneOption]="item.commonDropdownConfig.noneOption || false"
                            [multiple]="item.commonDropdownConfig.multiple || false"
                            [selectAllButton]="item.commonDropdownConfig.multiple || false"
                        />
                    </div>
                }

                @if (item.type === 'dropdown') {
                    <div class="mrr-1">
                        <mat-form-field data-testid="advanced-search-form">
                            <mat-label>{{ item.label }}</mat-label>
                            <mat-select
                                [(ngModel)]="formValues[item.name]"
                                (ngModelChange)="onSearch()"
                                [ngModelOptions]="{ standalone: true }"
                                data-testid="select"
                            >
                                <cdk-virtual-scroll-viewport
                                    (scrolledIndexChange)="onScrollEnd(i, item, $event)"
                                    [itemSize]="16"
                                    class="custom-scroll-viewport"
                                >
                                    <mat-option *cdkVirtualFor="let option of item.options" [value]="option.value">
                                        {{ option.label }}
                                    </mat-option>
                                </cdk-virtual-scroll-viewport>
                            </mat-select>
                        </mat-form-field>
                    </div>
                }

                @if (item.type === 'multiple-dropdown') {
                    <ng-container *ngTemplateOutlet="commonMultipleDropdownTemplate; context: { item: item }"></ng-container>
                }

                @if (item.type === 'datepicker') {
                    <div class="mrr-1">
                        <mat-form-field>
                            <mat-label>{{ item.label }}</mat-label>
                            <input
                                [(ngModel)]="formValues[item.name]"
                                (ngModelChange)="onSearch()"
                                [matDatepicker]="picker"
                                [ngModelOptions]="{ standalone: true }"
                                matInput
                            />
                            <mat-datepicker-toggle [for]="picker" matIconSuffix></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                    </div>
                }

                @if (item.type === 'dateRangePicker') {
                    <div class="mrr-1 date-picker">
                        <mat-form-field>
                            <app-common-date-range (dateRangeChanged)="onDateRangeChanged($event)" [dateRange]="formValues[item.name]" />
                        </mat-form-field>
                    </div>
                }
            </ng-container>
        }

        @if (showSubmit) {
            <button class="mrr-1" (click)="onSubmit()" color="primary" mat-flat-button>{{showSubmitLabel}}</button>
        }

        <button (click)="setDefaultValues()" color="primary" mat-flat-button>Сброс</button>
    </form>
    <!-- Predefined filters sets -->
    @if (presets?.length) {
        @for (filterSet of presets; track $index) {
            <button
                (click)="applyPredefinedFilters(filterSet)"
                [ngClass]="{ 'bg-green-light': activePresets.has(filterSet.name) }"
                mat-button
                color="primary"
            >
                {{ filterSet.name }}
            </button>
        }

                <mat-checkbox [formControl]="appendMode">Одновременно</mat-checkbox>
    }
</div>

<ng-template #commonMultipleDropdownTemplate let-item="item">
    @if (!item.hidden) {
        <mat-form-field class="mrr-1" [matBadge]="formValues[item.name]?.length || null">
            <mat-label>{{ item.label }}</mat-label>
            <mat-select multiple [(ngModel)]="formValues[item.name]" [ngModelOptions]="{ standalone: true }" (ngModelChange)="onSearch()">
                <cdk-virtual-scroll-viewport class="custom-scroll-viewport" [itemSize]="16" (scrolledIndexChange)="onScrollEnd(item)">
                    <mat-option *cdkVirtualFor="let option of item.options" [value]="option.value">
                        {{ option.label }}
                    </mat-option>
                </cdk-virtual-scroll-viewport>
            </mat-select>
        </mat-form-field>
    }
</ng-template>
